<template>
  <b-container>
    <b-row>
      <b-col>
        <h4 class="package-title">ATENTIE!</h4>
        <p style="white-space: pre-line;">
          Va informam ca legislatia in vigoare in Romania impune transportatorilor aerieni care opereaza pe teritoriul Romaniei sa mentioneze in rezervari,
          <b>datele de indentificare ale pasagerilor</b>, din documentele cu care acestia calatoresc pe curse internationale!
          Emiterea biletelor nu este posibila fara introducerea prealabila in rezervare a acestor date.
          <b>Va rugam NU introduceti date fictive!</b> Acestea vor trebui completate exact asa cum apar pe documentele de calatorie. Orice modificare presupune penalizari!
          Va rugam sa informati pasagerii ca la imbarcare sa se prezinte cu documentul de identitate care contine datele ce au fost introduse in sistem!
        </p>
        <p class="text-danger">
          <b>Atentie!: Pentru pasagerii anulati nu este nevoie sa completati datele!</b>
        </p>
        <h5 class="package-title">
          Date pasageri
          <small>(campurile marcate cu * sunt obligatorii)</small>
        </h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <hr>
        <h6 class="booking-details-title">Nume Prenume (ADT)</h6>
        <b-card>
          <b-row>
            <b-col sm="4">
              <b-form-group
                label="*Sex"
                label-class="font-weight-bold my-0 py-0"
                label-for="gender"
              >
                <b-form-select
                  id="gender"
                  size="sm"
                  v-model="gender"
                  :options="gender"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="8">
              <b-form-group
              label="Adresa"
              label-class="font-weight-bold my-0"
              label-for="address"
              >
              <b-input
                type="text"
                name="address"
                id="address"
                size="sm" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-form-group
                label="Tara domiciliu"
                label-class="font-weight-bold my-0 py-0"
                label-for="country"
              >
                <b-form-select
                  id="country"
                  size="sm"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label="Nationalitate"
                label-class="font-weight-bold my-0 py-0"
                label-for="countryName"
              >
                <b-form-select
                  id="countryName"
                  size="sm"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label="Nascut in"
                label-class="font-weight-bold my-0 py-0"
                label-for="birthCountry"
              >
                <b-form-select
                  id="birthCountry"
                  size="sm"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label="Document identitate"
                label-class="font-weight-bold my-0 py-0"
                label-for="identityDoc"
              >
                <b-form-select
                  id="identityDoc"
                  size="sm"
                  :options="documentTypes"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-form-group
              label="Serie & Nr. document"
              label-class="font-weight-bold my-0"
              label-for="noDoc"
              >
              <b-input
                type="text"
                name="noDoc"
                id="noDoc"
                size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label="Emis in"
                label-class="font-weight-bold my-0 py-0"
                label-for="emitted"
              >
                <b-form-select
                  id="emitted"
                  size="sm"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label="Data emitere"
                label-class="font-weight-bold my-0 py-0"
              >
                <DatePicker
                  class="datePiker"
                  format="dd/MM/yyyy"
                  bootstrap-styling
                  typeable
                  calendar-button-icon="fas fa-calendar-alt"
                  input-class="form-control-sm"
                ></DatePicker>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group
                label="Expira"
                label-class="font-weight-bold my-0 py-0"
              >
                <DatePicker
                  class="datePiker"
                  format="dd/MM/yyyy"
                  bootstrap-styling
                  typeable
                  calendar-button-icon="fas fa-calendar-alt"
                  input-class="form-control-sm"
                ></DatePicker>
              </b-form-group>
            </b-col>
            <b-col>
              <p class="text-danger">*Pentru campul cu <b>“Serie &amp; Nr. document”</b>, formatul de introducere a datelor este: <b>Carte de identitate</b>: serie si numar (fara spatii) / <b>Pasaport</b>: numar pasaport</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="*Telefon"
                label-class="font-weight-bold my-0"
                label-for="telephone"
                >
                <b-input
                  type="text"
                  name="telephone"
                  id="telephone"
                  size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Email"
                label-class="font-weight-bold my-0"
                label-for="email"
                >
                <b-input
                  type="text"
                  name="email"
                  id="email"
                  size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <small>*Va rugam sa completati un nr. de telefon si o adresa de email, la care pot fi contactati turistii in timp util, in cazul unor situatii de urgenta.</small>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Note detalii pasageri"
                label-class="font-weight-bold my-0"
              >
                <textarea class="form-control"></textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DatePicker from 'b2b-common/components/datepicker'

export default {
  name: 'editPassenger',
  components: { DatePicker },
  data () {
    return {
      gender: ['M', 'F'],
      documentTypes: [
        { value: 'P', text: 'Passport' },
        { value: 'C', text: 'National Identity Card' },
        { value: 'M', text: 'Military Identification' },
        { value: 'D', text: 'Diplomatic Passport/Card' },
        { value: 'G', text: 'Group Passport' }
      ]
    }
  }
}
</script>
